import { render, staticRenderFns } from "./BelowExcessReports.vue?vue&type=template&id=3295560c&scoped=true"
import script from "./BelowExcessReports.vue?vue&type=script&lang=js"
export * from "./BelowExcessReports.vue?vue&type=script&lang=js"
import style0 from "./BelowExcessReports.vue?vue&type=style&index=0&id=3295560c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3295560c",
  null
  
)

export default component.exports